import { useTranslation } from 'react-i18next'
import { LanguageIcon } from '@heroicons/react/24/outline'
import { SUPPORTED_LANGUAGES } from '../../i18n'

interface Props {
  /** Variante « claire » pour fonds sombres (ex. page de connexion). */
  light?: boolean
}

/** Sélecteur de langue (français / anglais / malgache). */
export default function LanguageSwitcher({ light }: Readonly<Props>) {
  const { i18n, t } = useTranslation()
  const base = light ? 'bg-white/10 text-white border-white/20' : 'bg-white text-gray-700 border-surface-border'

  return (
    <label className="inline-flex items-center gap-1.5">
      <LanguageIcon className={`h-4 w-4 ${light ? 'text-white/80' : 'text-gray-400'}`} aria-hidden="true" />
      <span className="sr-only">{t('common.language')}</span>
      <select
        aria-label={t('common.language')}
        value={i18n.resolvedLanguage}
        onChange={e => i18n.changeLanguage(e.target.value)}
        className={`text-sm rounded-lg border px-2 py-1 ${base} focus:ring-2 focus:ring-brand-500`}
      >
        {SUPPORTED_LANGUAGES.map(l => (
          <option key={l.code} value={l.code} className="text-gray-900">{l.label}</option>
        ))}
      </select>
    </label>
  )
}
